<div class="ds-form">
	<form
		#form="ngForm"
		(submit)="onTestSubmit($event)">
		<div class="ds-form__row">
			<eif-custom-input
				[(ngModel)]="formFields.username.value"
				[name]="'username'"
				[label]="'Username'"
				[placeholder]="'Try \'invalid\' to test server validation'"
				[required]="true"
				(valueChange)="onValueChange('username', $event)"
				(validationChange)="onValidationChange('username', $event)">
			</eif-custom-input>

			<eif-custom-input
				[(ngModel)]="formFields.email.value"
				[name]="'email'"
				[label]="'Email'"
				[type]="'email'"
				[placeholder]="'Try \'blocked&#64;example.com\' to test'"
				[required]="true"
				[validateEmail]="true"
				(valueChange)="onValueChange('email', $event)"
				(validationChange)="onValidationChange('email', $event)">
			</eif-custom-input>
		</div>

		<div class="ds-form__row">
			<eif-custom-input
				[(ngModel)]="formFields.password.value"
				[name]="'password'"
				[label]="'Password'"
				[type]="'password'"
				[placeholder]="'Try \'password\' to test server validation'"
				[required]="true"
				[minLength]="6"
				[maxLength]="12"
				(valueChange)="onValueChange('password', $event)"
				(validationChange)="onValidationChange('password', $event)">
			</eif-custom-input>
		</div>

		<div class="ds-status ds-mt-2">
			<h4 class="ds-status__title">Form Values</h4>
			<div class="ds-status__grid">
				<div class="ds-status__item">
					<strong>Username:</strong>
					<span>{{ formFields.username.value || 'Not entered' }}</span>
				</div>
				<div class="ds-status__item">
					<strong>Email:</strong>
					<span>{{ formFields.email.value || 'Not entered' }}</span>
				</div>
				<div class="ds-status__item">
					<strong>Password:</strong>
					<span>{{ formFields.password.value ? '••••••••' : 'Not entered' }}</span>
				</div>
				<div class="ds-status__item">
					<strong>Form Valid:</strong>
					<span
						[class.valid]="isFormValid"
						[class.invalid]="!isFormValid">
						{{ isFormValid ? '✓ Valid' : '✗ Invalid' }}
					</span>
				</div>
			</div>
		</div>

		<div class="ds-form__actions">
			<eif-custom-button
				[type]="'submit'"
				[text]="'Submit Form'"
				[preIcon]="'fa-solid fa-paper-plane'"
				[loading]="isSubmitting"
				[disabled]="isSubmitting">
			</eif-custom-button>
		</div>
	</form>
</div>
